import { use } from "react";
import { AuthContext } from "@/context/AuthContext";
import { UserRoles } from "@/services/user-auth/user-roles";

export function useGetStripeRoles() {
	const authContext = use(AuthContext);

	const roles = authContext?.roles || [];

	const stripeRoles = roles.filter((role) =>
		Object.values(UserRoles).includes(role),
	);

	if (stripeRoles.length === 0 && authContext?.isAuthenticated)
		stripeRoles.push(UserRoles.BRONZE);

	return stripeRoles;
}
